import styled from 'styled-components';

const Content = styled.div`
  padding: 0px 15px;
  text-align: justify;
  overflow: auto;
`;

const Iframe = styled.iframe`
  border: 0;
`;

export default {
  Content,
  Iframe
};
